module.exports = __webpack_public_path__ + "img/predict-win-btn-icon.529f003c.png";